const addListeners = (parrent, element, blurFn, inputFn) => {
  element.addEventListener('input', inputFn)

  if (element.value) {
    parrent.classList.add('_notEmpty')
  }

  element.addEventListener('focus', blurFn)
  element.addEventListener('blur', blurFn)
}

const removeListeners = (element, blurFn, inputFn) => {
  element.removeEventListener('input', inputFn)
  element.removeEventListener('focus', blurFn)
  element.removeEventListener('blur', blurFn)
}

export default {
  bind (el) {
    if (!el.focusFn) {
      el.focusFn = () => {
        el.classList.toggle('_focus')
      }
    }

    if (!el.inputFn) {
      el.inputFn = ({ data, target }) => {
        const value = data || target.value

        if (!value) {
          el.classList.remove('_notEmpty')

          return
        }

        el.classList.add('_notEmpty')
      }
    }

    const inputs = Array.from(el.getElementsByTagName('input'))
    const textareas = Array.from(el.getElementsByTagName('textarea'))

    const elInputs = inputs.concat(textareas)

    elInputs.forEach(element => {
      addListeners(el, element, el.focusFn, el.inputFn)
    })
  },
  unbind (el) {
    const inputs = Array.from(el.getElementsByTagName('input'))
    const textareas = Array.from(el.getElementsByTagName('textarea'))

    const elInputs = inputs.concat(textareas)

    elInputs.forEach(element => {
      removeListeners(element, el.focusFn, el.inputFn)
    })
  }
}
